import Vue from "vue";
import VueRouter from "vue-router";
// import store from "./../store";
import auth from "./routes/auth";
import report from "./routes/report";
import basic_data from "./routes/basic_data";
import volunteer from "./routes/volunteer";
import patient from "./routes/patient";
import activity from "./routes/activity";
import user_accounts from "./routes/user_accounts";
import data_import from "./routes/data_import";

Vue.use(VueRouter);

const routes = [
  ...auth,
  ...report,
  ...basic_data,
  ...volunteer,
  ...patient,
  ...activity,
  ...user_accounts,
  ...data_import,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("MDR_DASHBOARD_TOKEN");

  if (to.matched.some((record) => record.meta.forAuth) && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
